import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" | ");
  return JSON.stringify(d);
}

export const STATUS_LABELS = {
  pending_qc: "Pending QC",
  approved: "Approved",
  rejected: "Rejected",
  mixed: "Mixed",
  dispatched: "Dispatched",
  transferred: "Transferred",
  in_transit: "In Transit",
};

export function statusBadgeClass(status) {
  if (status === "pending_qc") return "badge badge-pending";
  if (status === "approved") return "badge badge-approved";
  if (status === "rejected") return "badge badge-rejected";
  if (status === "mixed") return "badge badge-mixed";
  if (status === "dispatched") return "badge badge-dispatched";
  if (status === "transferred") return "badge badge-transferred";
  if (status === "in_transit") return "badge badge-transit";
  return "badge";
}

export const LOCATIONS = ["FACTORY", "MAGHVEERA", "BAIKAMPADY"];

export const SPEC_KEYS = [
  { key: "protein", label: "Protein", suffix: "%" },
  { key: "moisture", label: "Moisture", suffix: "%" },
  { key: "fat", label: "Fat", suffix: "%" },
  { key: "ash", label: "Ash", suffix: "%" },
  { key: "salt", label: "Salt", suffix: "%" },
  { key: "tvn", label: "TVN", suffix: " mg/100g" },
  { key: "ffa", label: "FFA", suffix: "%" },
  { key: "sand", label: "Sand", suffix: "%" },
  { key: "histamine", label: "Histamine", suffix: " ppm" },
];

export function todayISO() {
  return new Date().toISOString().slice(0, 10);
}

export function fmtNum(n, digits = 0) {
  if (n === null || n === undefined || n === "") return "—";
  const v = Number(n);
  if (Number.isNaN(v)) return "—";
  return v.toLocaleString(undefined, { minimumFractionDigits: digits, maximumFractionDigits: digits });
}
